import { Constants } from "./constants";
import { Utilities } from "./utilities";

export class LocaleFile {
  _resources: Object;

  constructor() {
    this._resources = {};
    this._resources[Constants.$Schema] = Constants.MosManifestLocalizationSchemaVersionGA;
  }

  addResource(key: string, value: string): void {
    Utilities.assert(Utilities.isNullOrUndefined(this._resources[key]), "resource should not already have been added");
    this._resources[key] = value;
  }

  getResources(): object {
    return this._resources;
  }
}
